import { createSelector } from '@ngrx/store';

const selectOAuth = (state: any) => state.oauth;

export const selectHubspotLoginSuccess = createSelector(
  selectOAuth,
  (state) => state
);

export const selectHubspotLoginFailure = createSelector(
  selectOAuth,
  (state) => state.error
);
export const selectHubspotCallbackSuccess = createSelector(
  selectOAuth,
  (state) => state
);

export const selectHubspotCallbackFailure = createSelector(
  selectOAuth,
  (state) => state.error
);

export const selectHubspotLogoutSuccess = createSelector(
  selectOAuth,
  (state) => state
);

export const selectHubspotLogoutFailure = createSelector(
  selectOAuth,
  (state) => state.error
);

export const selectIsConnectedToHubspot = createSelector(
  selectOAuth,
  (state) => state.isConnectedToHubspot
);

export const selectIsConnectedToLivespace = createSelector(
  selectOAuth,
  (state) => state.isConnectedToLivespace
);

export const selectIsLoading = createSelector(
  selectOAuth,
  (state) => state.isLoading
);

export const selectGoogleLoginSuccess = createSelector(
  selectOAuth,
  (state) => state
);

export const selectGoogleLoginFailure = createSelector(
  selectOAuth,
  (state) => state.error
);
export const selectGoogleCallbackSuccess = createSelector(
  selectOAuth,
  (state) => state
);

export const selectGoogleCallbackFailure = createSelector(
  selectOAuth,
  (state) => state.error
);

export const selectGoogleLogoutSuccess = createSelector(
  selectOAuth,
  (state) => state
);

export const selectGoogleLogoutFailure = createSelector(
  selectOAuth,
  (state) => state.error
);
